import { useMemo } from 'react'
import { useLocation } from 'react-router'
import { Menu as UikitMenu } from 'vvs-uikit'
import { languageList } from 'config/localization/languages'
import { useTranslation } from 'contexts/Localization'
import useTheme from 'hooks/useTheme'
import { usePollBlockNumber } from 'state/block/hooks'
import { usePollCoreFarmData, usePriceVvsUsdc } from 'state/farms/hooks'
import { usePollRemovalOrdersWithUserData } from 'state/burn/hooks'
import { useLocalCurrencyExRate } from 'utils/useLocalCurrencyExRate'
import BigNumber from 'bignumber.js'
import { isBlindMode, showVvsPrice } from 'utils'
import { registerToken } from 'utils/wallet'
import getFiatValue from 'utils/getFiatValue'
import EasterEgg from 'components/EasterEgg'
import tokens from 'config/constants/tokens'
import { useSelector } from 'react-redux'
import { AppState, useAppDispatch } from 'state'
import localCurrencies from 'config/constants/localCurrencies'
import { DEFAULT_LOCAL_CURRENCY } from 'config/constants'
import { toggleMenuDisplay } from 'state/menu/actions'

import { footerLinks } from './config/footerConfig'
import config from './config/config'
import UserMenu from './UserMenu'
import GlobalSettings from './GlobalSettings'
import { getActiveMenuItem, getActiveSubMenuItem } from './utils'

const Menu = ({ children }) => {
  usePollBlockNumber()
  usePollCoreFarmData()
  usePollRemovalOrdersWithUserData()
  useLocalCurrencyExRate()

  const dispatch = useAppDispatch()
  const { isDark, toggleTheme } = useTheme()
  const vvsPriceUsd = usePriceVvsUsdc()
  const { currentLanguage, setLanguage, t } = useTranslation()
  const { pathname } = useLocation()
  const { localCurrency } = useSelector((state: AppState) => state.user)

  const menuConfig = useMemo(() => config(t), [t])
  const activeMenuItem = getActiveMenuItem({ menuConfig, pathname })
  const activeSubMenuItem = getActiveSubMenuItem({ menuItem: activeMenuItem, pathname })

  const shouldShowVvsPrice = showVvsPrice()
  const vvsFiatPrice: BigNumber = getFiatValue(vvsPriceUsd)

  return (
    <UikitMenu
      onChangeMenuVisibility={(isDisplay) => {
        dispatch(toggleMenuDisplay({ isDisplay }))
      }}
      userMenu={<UserMenu />}
      globalMenu={<GlobalSettings color="white" />}
      isDark={isDark}
      isBlindMode={isBlindMode()}
      toggleTheme={toggleTheme}
      t={t}
      currentLang={currentLanguage.code}
      langs={languageList}
      setLang={setLanguage}
      vvsPriceUsd={vvsPriceUsd.toNumber()}
      vvsFiatPrice={vvsFiatPrice.toNumber()}
      vvsPriceSymbol={`${localCurrencies[localCurrency]?.symbol ?? localCurrencies[DEFAULT_LOCAL_CURRENCY].symbol}`}
      showVvsPrice={shouldShowVvsPrice}
      links={menuConfig}
      subLinks={activeMenuItem?.hideSubNav ? [] : activeMenuItem?.items}
      footerLinks={footerLinks(t)}
      activeItem={activeMenuItem?.href}
      activeSubItem={activeSubMenuItem?.href}
      buyVvsLabel={t('Buy VVS')}
      iconCallback={() => registerToken(tokens.vvs.address, tokens.vvs.symbol, tokens.vvs.decimals)}
      vvsAddress={tokens.vvs.address}
    >
      {children}

      <EasterEgg iterations={2} />
    </UikitMenu>
  )
}

export default Menu
